enum ContractStatus {
    Inactive = 0,
    Active = 1,
    Stopped = 2,
    Terminated = 3
}

export default ContractStatus;